export const FETCH_SALES_EVENTS_REQUESTED =
  'FETCH_SALES_EVENTS_REQUESTED'
export const FETCH_SALES_EVENTS_SUCCEDED =
  'FETCH_SALES_EVENTS_SUCCEDED'
export const FETCH_SALES_EVENTS_FAILED = 'FETCH_SALES_EVENTS_FAILED'

export const CREATE_SALES_EVENTS_REQUESTED =
  'CREATE_SALES_EVENTS_REQUESTED'
export const CREATE_SALES_EVENTS_SUCCEDED =
  'CREATE_SALES_EVENTS_SUCCEDED'
export const CREATE_SALES_EVENTS_FAILED = 'CREATE_SALES_EVENTS_FAILED'

export const UPDATE_SALES_EVENTS_REQUESTED =
  'UPDATE_SALES_EVENTS_REQUESTED'
export const UPDATE_SALES_EVENTS_SUCCEDED =
  'UPDATE_SALES_EVENTS_SUCCEDED'
export const UPDATE_SALES_EVENTS_FAILED = 'CREATE_SALES_EVENTS_FAILED'
